
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'icon-my-collections',
    styleUrls: ['./icon-my-collections.component.scss'],
    template: `
        @if (isInCollection) {
          <div class="is-in-collection">
            <i class="fa-solid fa-rectangle-history fa-lg"></i>
          </div>
        }
        
        @if (!isInCollection) {
          <div class="not-in-collection">
            <i class="fa-light fa-rectangle-history fa-lg"></i>
          </div>
        }
        `,
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class IconMyCollectionsComponent {
	@Input() isInCollection: boolean;
}
